<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{"num_cand":"U2FsdGVkX19L2l4z4onAWlWSvlsRggAnQnE+L7Asmv8=","cpf":"U2FsdGVkX18/ETzxOTM+pNNPSRqLWlt8PgHdBN4m8U0="},{"num_cand":"U2FsdGVkX196e5b/YnDmymXB001f1gPZhnH8NBrSIn8=","cpf":"U2FsdGVkX1/MPMmuSSXAJez33ePpcrV3Wbwy/Kk8etY="},{"num_cand":"U2FsdGVkX1/alAOPA/Xd7oQ2hmIZvP2rk60HIcJJx80=","cpf":"U2FsdGVkX1+fQjVq87N6eceKzV27IQstfgeHYy1ltAA="},{"num_cand":"U2FsdGVkX19Li6fLjBacup8fa2+Y+z5FYYryBjpKzis=","cpf":"U2FsdGVkX1+hzcvgeruBZt+GP2MgaZiudBSV72IneuY="},{"num_cand":"U2FsdGVkX18JWtznwAB/+8BkHABMJpeQQj743h4Hctw=","cpf":"U2FsdGVkX19DyDLl8gu8YbvRYevFwTA6EohmXhHeALs="},{"num_cand":"U2FsdGVkX1/pM4lLy0XwZFNaNXuofw7mxXoh9zmY49Y=","cpf":"U2FsdGVkX1+JeADgym5JAEqSwYrAcu3Sh0CSwhB1N9s="},{"num_cand":"U2FsdGVkX19ZDFYyvb27fhbEiQucpo+ozvrXa5OdBlg=","cpf":"U2FsdGVkX19ve7WQaRf67wlywa1YxRJhtiROdf2JIXs="},{"num_cand":"U2FsdGVkX19IjtcwlQh8rHFVc5rfW6Cj6a3Vg5WS2uA=","cpf":"U2FsdGVkX1/Xx+VDehIebCGfxQRphfABEf1yFw87Igk="},{"num_cand":"U2FsdGVkX1+3h2hGCnL+N/5UxgAt3JwPVJmYg/QMjmY=","cpf":"U2FsdGVkX1+4R+JXh/BnRxT18SrldYYPXC6EGtSii/U="},{"num_cand":"U2FsdGVkX1+a3Me1HY5DFGZKzRL+bQExNnGg8Kq8wL8=","cpf":"U2FsdGVkX1/gttSRyDq2xFmOoa9AQF1mjQZ0VxtiBrs="},{"num_cand":"U2FsdGVkX19/eBwZs+p81Rm3vjx0Gdc5m7DhoTiPECE=","cpf":"U2FsdGVkX19qcfb5Nrpc3evqlG5JmxLvaTAN25w0ILI="},{"num_cand":"U2FsdGVkX1+IW9etNlTbV0opbNDwov1reA3xELcUEzA=","cpf":"U2FsdGVkX18NHm2j9vFjqRf4Cuy+MgMlc81337KZ99o="},{"num_cand":"U2FsdGVkX19frg2XvEZ/enqYKuFedcBEIvPEcwZX2i0=","cpf":"U2FsdGVkX1+YjBYH54PsLIRsv/XVkHuPRt/pGfz3qLU="},{"num_cand":"U2FsdGVkX18fpLfr/VR6C9WcA/Mh2gv5KIDxKnrpgjs=","cpf":"U2FsdGVkX1/g8WDSGcSGel5nRfQJAXahG+/lK0FiqfE="},{"num_cand":"U2FsdGVkX18C42xrMgpWiASJN8rhgCzLsxRL9oLt/Lk=","cpf":"U2FsdGVkX1/2C0BwpTt8FKHmrlKKpYgkG0wVheAuHvk="},{"num_cand":"U2FsdGVkX1+x3i3j+mawbC9DFfAVCqLaxelUeVGMJVA=","cpf":"U2FsdGVkX18/asild9z6+9sQ+1aonf8QsaShWfRa+nI="},{"num_cand":"U2FsdGVkX1+oaYwnHfFi6Okov2RbpGurUGnqkJX8KTM=","cpf":"U2FsdGVkX1+xtZmJBn7+wPDiD5yUiAlGqpuqoV59gtI="},{"num_cand":"U2FsdGVkX1+pDs8ugb1Xso+K6wDQm/QHoDsp5rYxBKk=","cpf":"U2FsdGVkX19ligwajR8Neh8Kczd94wK2p303I1c3NKM="},{"num_cand":"U2FsdGVkX192bB7p1DirkSbrG+bXjTJ7sajkeGXxT1k=","cpf":"U2FsdGVkX1/jQAWMgWmJemw9GdN9Fdzc+Vy4VSuIiK0="},{"num_cand":"U2FsdGVkX1+raSOcWXIOAHSgQBXfUuru2W/VRRZjRos=","cpf":"U2FsdGVkX1+Wg8Gi7lrOM22lupWMqDNSTDJRFgd4+oM="},{"num_cand":"U2FsdGVkX19XBNJSqXAaVKvf3cqB/Cqh8oF1l7a6R4A=","cpf":"U2FsdGVkX19LlTnvyWATUSUJUPfIbCCXOsod9GXRPXs="},{"num_cand":"U2FsdGVkX1/ZKnZy5MJCnjC3SBc89/b+uAkdgHuQFoE=","cpf":"U2FsdGVkX181CksywVv963hFKUlRRAhVV8YHRnXkRNQ="},{"num_cand":"U2FsdGVkX19ByeZY01hCg3S8qxxPBw8XkiumADSay8c=","cpf":"U2FsdGVkX19jDJ6Z3knciTA/g3UN4k0y8i0RvfDUTfU="}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2219/rec_po/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
